export { default } from './LoadingPlaceholder'
